<div class="profile-completion-modal">

  <div class="modal-header" *ngIf="progressBar.total > 1">
    <app-progress-bar [noOfView]="progressBar.total" [signUpPageCount]="progressBar.completed" class="progress-bar"></app-progress-bar>
  </div>

  <app-profile-completion-modal *ngIf="modalType.profileCompletion === activeModal" (action)="onAction($event)" [isNextModal]="noOfSurvey>0"></app-profile-completion-modal>
  <app-survey-completion-modal *ngIf="modalType.surveyCompletion === activeModal" (action)="onAction($event)"></app-survey-completion-modal>

</div>
